export default __webpack_public_path__ + "static/media/kw.03dcb08d.svg";